export interface CrudTableTagItemSettings {
  color?: string;
}
